import { useState, useEffect } from "react";
import "../css/PartidosFaseGrupos.css";
import { Fase, MULTIPLICADORES } from "../shared/multiplicadores";



interface PartidosFaseGruposProps {
  partido: {
    id: number;
    local_nombre: string;
    visitante_nombre: string;
    fecha: string;

    // 👇 NUEVO (opcional, no rompe nada)
    goles_local?: number | null;
    goles_visitante?: number | null;
  };
  fase: Fase;
  prediccion?: {
    prediccion_local: number;
    prediccion_visitante: number;
    apuesta: number;
  };
  puntosDisponibles: number;
  guardando: boolean;
  onClose: () => void;
  onSave: (gLocal: number, gVisitante: number, apuesta: number) => void;
}



const PartidosFaseGrupos = ({
  partido,
  fase, // 👈 ESTO FALTABA
  prediccion,
  puntosDisponibles,
  guardando,
  onClose,
  onSave,
}: PartidosFaseGruposProps) => {


  const [gLocal, setGLocal] = useState(0);
  const [gVisitante, setGVisitante] = useState(0);
  const [puntosApostados, setPuntosApostados] = useState("");
  const [gananciaPosible, setGananciaPosible] = useState(0);
  

  const apuestaAnterior = prediccion?.apuesta ?? 0;
  const maxApuesta = puntosDisponibles + apuestaAnterior;

const handleApuestaChange = (value: string) => {
  // permitir vacío
  if (value === "") {
    setPuntosApostados("");
    return;
  }

  // eliminar ceros a la izquierda (pero dejar un solo 0 si es el caso)
  const limpio = value.replace(/^0+(?!$)/, "");

  const num = Number(limpio);

  if (Number.isNaN(num) || num < 0) return;

  if (num > maxApuesta) {
    setPuntosApostados(String(maxApuesta));
    return;
  }

  setPuntosApostados(limpio);
};

  
useEffect(() => {
  const parcial = 20;
  const multiplicador = MULTIPLICADORES[fase];
  const apuestaNum = Number(puntosApostados || 0);
  setGananciaPosible(apuestaNum * multiplicador + parcial);
}, [puntosApostados, fase]);

useEffect(() => {
  if (prediccion) {
    setGLocal(prediccion.prediccion_local);
    setGVisitante(prediccion.prediccion_visitante);
    setPuntosApostados(String(prediccion.apuesta));
  } else {
    // si es una predicción nueva
    setGLocal(0);
    setGVisitante(0);
    setPuntosApostados("0");
  }
}, [prediccion]);


// ✅ ACÁ, antes de usarlo
const partidoLiquidado =
  typeof partido.goles_local === "number" &&
  typeof partido.goles_visitante === "number";

const puntosObtenidos =
  prediccion && partidoLiquidado
    ? (() => {
        const gl = partido.goles_local!;
        const gv = partido.goles_visitante!;

        const aciertaResultado =
          (gl > gv && prediccion.prediccion_local > prediccion.prediccion_visitante) ||
          (gl < gv && prediccion.prediccion_local < prediccion.prediccion_visitante) ||
          (gl === gv &&
            prediccion.prediccion_local === prediccion.prediccion_visitante);

        const aciertaExacto =
          gl === prediccion.prediccion_local &&
          gv === prediccion.prediccion_visitante;

        let puntos = 0;
        if (aciertaResultado) puntos += 20;
        if (aciertaExacto) puntos += prediccion.apuesta * MULTIPLICADORES[fase];

        return puntos;
      })()
    : null;

const puedeEditar = !partidoLiquidado;
const puntosDisponiblesReales = Math.max(
  0,
  puntosDisponibles + apuestaAnterior - Number(puntosApostados || 0)
);


  return (
  <div className="panel-overlay fade-in">
    <div className="panel slide-up">
      <button className="panel-close" onClick={onClose}>✕</button>

      <h2>{partido.local_nombre} vs {partido.visitante_nombre}</h2>
      <p>{new Date(partido.fecha).toLocaleString()}</p>

      <div className="score-box">
        <div>
          <strong>{partido.local_nombre}</strong>
          <div className="score-controls">
            <button disabled={!puedeEditar} onClick={() => setGLocal(Math.max(0, gLocal - 1))}>-</button>
            <span>{gLocal}</span>
            <button disabled={!puedeEditar} onClick={() => setGLocal(gLocal + 1)}>+</button>
          </div>
        </div>

        <div>
          <strong>{partido.visitante_nombre}</strong>
          <div className="score-controls">
            <button disabled={!puedeEditar} onClick={() => setGVisitante(Math.max(0, gVisitante - 1))}>-</button>
            <span>{gVisitante}</span>
            <button disabled={!puedeEditar} onClick={() => setGVisitante(gVisitante + 1)}>+</button>
          </div>
        </div>
      </div>

      <div className="puntos-section">
        <h3 className="puntos-title">¿Cómo se suman los puntos?</h3>

        {partidoLiquidado && (
          <>
            <div className="resultado-real">
              <strong>Resultado final:</strong>{" "}
              {partido.goles_local} - {partido.goles_visitante}
            </div>

            {puntosObtenidos !== null && (
              <div className="puntos-ganados">
                ⭐ <strong>Puntos obtenidos:</strong> {puntosObtenidos}
              </div>
            )}
          </>
        )}

        <ul className="puntos-explicacion">
          <li>✅ <strong>+20 pts</strong> si acertás ganador o empate</li>
          <li>
            🔥 <strong>Tu apuesta × {MULTIPLICADORES[fase]}</strong> si acertás el resultado exacto
          </li>
        </ul>

        <p className="puntos-disponibles">
          Puntos disponibles:
          <strong> {puntosDisponiblesReales} pts</strong>
        </p>


        <div className="puntos-input">
          <label>¿Cuántos puntos querés apostar?</label>
          <input
              type="number"
              min={0}
              max={maxApuesta}
              value={puntosApostados}
              disabled={!puedeEditar}
              onChange={(e) => handleApuestaChange(e.target.value)}
            />
        </div>

        <p className="puntos-total">
          Ganancia máxima posible:
          <strong> {gananciaPosible} pts</strong>
        </p>
      </div>

      {puedeEditar ? (
        <button
          className="save-btn"
          disabled={guardando}
          onClick={() => onSave(gLocal, gVisitante, Number(puntosApostados || 0))}
        >
          {guardando
            ? "Guardando..."
            : prediccion
            ? "Editar predicción"
            : "Guardar predicción"}
        </button>
      ) : (
        <button className="save-btn disabled" disabled>
          Partido finalizado
        </button>
      )}
    </div>
  </div>
);

};

export default PartidosFaseGrupos;
